import { z } from 'zod';
/**
 * A single message within a conversation.
 */
export const ConversationMessageSchema = z.object({
    id: z.string(),
    conversationId: z.string(),
    role: z.enum(['user', 'assistant']),
    content: z.string(),
    timestamp: z.string(),
    statsJson: z.string().optional(),
    intent: z.string().optional(),
});
//# sourceMappingURL=conversation-message.js.map